/* istanbul ignore file: untested, please test */

import { PropsWithChildren, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { AnalyticsDataPageScreenType } from 'src/types/googleAnalyticsEvents';
import { PageContainer, PageSocialMeta } from 'src/containers';
import { getTargetMessages } from 'src/utils/getTargetMessages';
import { pageWithLayout } from 'src/utils/pageWithLayout';
import { PussInBootsPageContent } from '../PussInBootsTopicOfTopicPageContent';
import { getPreviewImage } from '../utils/getPreviewImage';
import { PussInBootsPageProps } from '../types/pussInBootsPageProps';
import * as localesWithMessages from './messages';

const PussInBootsPageLayout = ({
  pageUrlMeta,
  languagePair,
  targetLanguages,
  children,
}: PropsWithChildren<PussInBootsPageProps>) => {
  const intl = useIntl();
  const { targetLanguageLocale, sourceLanguageLocale } = languagePair;
  const targetMsgs = getTargetMessages(localesWithMessages, targetLanguageLocale);
  const contentMeta = useMemo(
    () => ({
      contentType: AnalyticsDataPageScreenType.campaignRootPage,
      contentName: 'Puss in Boots',
      pageTitle: intl.formatMessage(targetMsgs.title),
      pageDescription: intl.formatMessage(targetMsgs.description),
    }),
    [intl, targetMsgs],
  );

  return (
    <PageContainer
      data-testid="pussInBootsCampaignPage"
      urlMeta={pageUrlMeta}
      languagePair={languagePair}
      targetLanguages={targetLanguages}
      contentMeta={contentMeta}
    >
      <PageSocialMeta
        title={contentMeta.pageTitle}
        description={contentMeta.pageDescription}
        image={getPreviewImage(sourceLanguageLocale)}
      />
      {children}
    </PageContainer>
  );
};

export const PussInBootsTopicOfTopicPage = pageWithLayout(
  PussInBootsPageLayout,
  PussInBootsPageContent,
);
